import React from 'react';
import H3HeaderText from '../../ui/typography/H3HeaderText';
import BaseText from '../../ui/typography/BaseText';
import Store from '../../../images/inline/store.inline.svg';
import Material from '../../../images/inline/material.inline.svg';
import Restaurant from '../../../images/inline/restaurant.inline.svg';
import Hotel from '../../../images/inline/hotel.inline.svg';
import Shipping from '../../../images/inline/shipping.inline.svg';
import Confirmation from '../../../images/inline/confirmation.inline.svg';
import School from '../../../images/inline/school.inline.svg';
import Terminal from '../../../images/inline/terminal.inline.svg';
import Shopping from '../../../images/inline/shopping.inline.svg';
export default function Industry() {
  return (
    <section className="industry-container">
      <div className="global-max-width-wrapper mx-auto py-28">
        <div className="w-3/5 mx-auto flex flex-col justify-center items-center">
          <H3HeaderText
            fontWeight="text-medium"
            textAlign="text-center"
            textColor="text-blue-500"
            title="Hong Kong Business Registration for any industry"
          />
          <BaseText
            textAlign="text-center"
            className="mt-6"
            title="Hong Kong is fantastic for companies who want to do business offshore. But did you know that Hong Kong might just be the best place for your industry too? Here’s some industries we regularly help shuttle into the world’s trade and finance hub."
          />
        </div>
        <div className="flex flex-col md:flex-row items-center justify-center gap-12">
          <div className="flex flex-col items-center p-12">
            <div className="icon-circle bg-white relative z-10 text-32ct text-bold text-orange-500 rounded-full flex items-center justify-center">
              <Store />
            </div>
            <BaseText
              className="md:whitespace-pre-line mt-2"
              textAlign="text-center"
              fontWeight="text-medium"
              textColor="text-gray-300"
              title={`Remote Hong Kong \ncompany registration`}
            />
          </div>
          <div className="flex flex-col items-center p-12">
            <div className="icon-circle bg-white relative z-10 text-32ct text-bold text-orange-500 rounded-full flex items-center justify-center">
              <Material />
            </div>
            <BaseText
              className="md:whitespace-pre-line mt-2"
              textAlign="text-center"
              fontWeight="text-medium"
              textColor="text-gray-300"
              title={`Remote Hong Kong \ncompany registration`}
            />
          </div>
          <div className="flex flex-col items-center p-12">
            <div className="icon-circle bg-white relative z-10 text-32ct text-bold text-orange-500 rounded-full flex items-center justify-center">
              <Restaurant />
            </div>
            <BaseText
              className="md:whitespace-pre-line mt-2"
              textAlign="text-center"
              fontWeight="text-medium"
              textColor="text-gray-300"
              title={`Remote Hong Kong \ncompany registration`}
            />
          </div>
        </div>
        <div className="flex flex-col md:flex-row items-center justify-center gap-12">
          <div className="flex flex-col items-center p-12">
            <div className="icon-circle bg-white relative z-10 text-32ct text-bold text-orange-500 rounded-full flex items-center justify-center">
              <Hotel />
            </div>
            <BaseText
              className="md:whitespace-pre-line mt-2"
              textAlign="text-center"
              fontWeight="text-medium"
              textColor="text-gray-300"
              title={`Remote Hong Kong \ncompany registration`}
            />
          </div>
          <div className="flex flex-col items-center p-12">
            <div className="icon-circle bg-white relative z-10 text-32ct text-bold text-orange-500 rounded-full flex items-center justify-center">
              <Shipping />
            </div>
            <BaseText
              className="md:whitespace-pre-line mt-2"
              textAlign="text-center"
              fontWeight="text-medium"
              textColor="text-gray-300"
              title={`Remote Hong Kong \ncompany registration`}
            />
          </div>
          <div className="flex flex-col items-center p-12">
            <div className="icon-circle bg-white relative z-10 text-32ct text-bold text-orange-500 rounded-full flex items-center justify-center">
              <Confirmation />
            </div>
            <BaseText
              className="md:whitespace-pre-line mt-2"
              textAlign="text-center"
              fontWeight="text-medium"
              textColor="text-gray-300"
              title={`Remote Hong Kong \ncompany registration`}
            />
          </div>
        </div>
        <div className="flex flex-col md:flex-row items-center justify-center gap-12">
          <div className="flex flex-col items-center p-12">
            <div className="icon-circle bg-white relative z-10 text-32ct text-bold text-orange-500 rounded-full flex items-center justify-center">
              <School />
            </div>
            <BaseText
              className="md:whitespace-pre-line mt-2"
              textAlign="text-center"
              fontWeight="text-medium"
              textColor="text-gray-300"
              title={`Remote Hong Kong \ncompany registration`}
            />
          </div>
          <div className="flex flex-col items-center p-12">
            <div className="icon-circle bg-white relative z-10 text-32ct text-bold text-orange-500 rounded-full flex items-center justify-center">
              <Terminal />
            </div>
            <BaseText
              className="md:whitespace-pre-line mt-2"
              textAlign="text-center"
              fontWeight="text-medium"
              textColor="text-gray-300"
              title={`Remote Hong Kong \ncompany registration`}
            />
          </div>
          <div className="flex flex-col items-center p-12">
            <div className="icon-circle bg-white relative z-10 text-32ct text-bold text-orange-500 rounded-full flex items-center justify-center">
              <Shopping />
            </div>
            <BaseText
              className="md:whitespace-pre-line mt-2"
              textAlign="text-center"
              fontWeight="text-medium"
              textColor="text-gray-300"
              title={`Remote Hong Kong \ncompany registration`}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
